import React, { useEffect, useState, useCallback } from 'react';
import { actions } from '../../state/actions';
import { connect } from 'react-redux';
import {
  WithSpinner,
  TableProjects,
  TableRowProject,
  TableCellProject,
  Button,
} from '../../components';

import styles from './requests.module.scss';

import swal from 'sweetalert';

import { format } from 'date-fns';
import { Link, Redirect } from 'react-router-dom';
import { config } from '../../api/config';
import { Api } from '../../api/api';
import { getLocalStorageItemIfNotExpired } from '../../utils';

const Projects = ({ projectList, dispatch, loading, canCreateRequest }) => {
  const tableHeader = ['Priemonė', 'Terminas', 'Kurti naują'];

  const [selectedId, setSelectedId] = useState(null);

  const actionClick = (action, Id) => {
    const loginType = getLocalStorageItemIfNotExpired('loginType');

    if (action === 'view') {
      if (loginType === 'Company') {
        dispatch(actions.dashboard.createNewRequestAction(Id, 'view'));
      } else if (loginType === 'Individual') {
        dispatch(
          actions.dashboard.createNewRequestIndividualAction(Id, 'view')
        );
      } else {
        swal({
          title: 'Įvyko klaida',
          icon: 'Error',
          buttons: {
            confirm: {
              text: 'Gerai',
              value: true,
              visible: true,
              className: 'btn swal-ok-btn',
              closeModal: true,
            },
          },
        });
      }

      setSelectedId(Id);
    }
  };
  const currentDate = new Date();
  const fetchdata = useCallback(() => {
    dispatch(actions.dashboard.getProjectListAction());
  }, [dispatch, projectList]);

  const [canCreateNewRequest, setCanCreateNewRequest] = useState(false);
  const addNewRequest = (projectId) => {
    const loginType = getLocalStorageItemIfNotExpired('loginType');

    // call cancreate request

    fetch(Api.API_BASE_URL + config.API_ENDPOINTS.canCreateRequest, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
      },
    })
      .then((res) => {
        if (res.ok === true) {
          res.json().then((r) => {
            if (r) {
              setCanCreateNewRequest(true);
              if (loginType === 'Company') {
                dispatch(
                  actions.dashboard.createNewRequestAction(
                    '',
                    '',
                    '',
                    projectId
                  )
                );
              } else if (loginType === 'Individual') {
                dispatch(
                  actions.dashboard.createNewRequestIndividualAction(
                    '',
                    '',
                    '',
                    projectId
                  )
                );
              } else {
                swal({
                  title: 'Klaida',
                  icon: 'Error',
                  buttons: {
                    confirm: {
                      text: 'Gerai',
                      value: true,
                      visible: true,
                      className: 'btn swal-ok-btn',
                      closeModal: true,
                    },
                  },
                });
              }
            } else {
              swal({
                title:
                  'Vienam paskolos gavėjui iš Priemonės lėšų gali būti suteikta tik viena paskola. Jūs jau esate pateikę paraišką paskolai gauti.',
                icon: 'info',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setCanCreateNewRequest(false);
      });
  };

  useEffect(() => {
    dispatch(actions.dashboard.clearUserStateAction());
    fetchdata();
    dispatch(actions.dashboard.setSavedRequestDesissionAccepted(false));
    dispatch(actions.auth.pushTokenToServerAction());
  }, []);

  return (
    <WithSpinner loading={loading}>
      <div
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
          textAlign: 'center',
          marginLeft: '10%',
          marginRight: '10%',
        }}
      ></div>
      {/*ideti Inactive patikra*/}
      <div
        style={{
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
          minWidth: '600px',
        }}
      >
        <h2 style={{ marginTop: '50px' }}>
          Pasirinkite priemonę, kuriai norite parengti paraišką
        </h2>

        <TableProjects
          header={tableHeader}
          isEmpty={false}
          style={{ background: '#000' }}
        >
          {projectList != null &&
            projectList.map(
              ({
                Id,
                Title,
                StartDate,
                EndDate,
                ContractSigningTerm,
                DescriptionUrl,
                ProjectDescription,
              }) => (
                <TableRowProject key={Id}>
                  <TableCellProject>
                    <h3>"{Title}"</h3>
                    <br />
                    {ProjectDescription}
                    <br />
                    <br />
                    Plačiau apie paskolos teikimo sąlygas galite pasiskaityti
                    čia:{' '}
                    <a
                      href={DescriptionUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {DescriptionUrl}
                    </a>
                    <br /> <br /> Paraiškų teikimo terminas iki:{' '}
                    <b>
                      {EndDate !== null &&
                        format(new Date(EndDate), 'yyyy-MM-dd')}
                    </b>{' '}
                    d.
                    <br />
                    Sutarčių pasirašymo terminas iki:{' '}
                    <b>
                      {ContractSigningTerm !== null &&
                        format(new Date(ContractSigningTerm), 'yyyy-MM-dd')}
                    </b>{' '}
                    d.
                  </TableCellProject>

                  <TableCellProject>
                    {format(new Date(currentDate), 'yyyy-MM-dd HH:mm:ss') <
                      format(new Date(EndDate), 'yyyy-MM-dd HH:mm:ss') && (
                      <div
                        className={styles.iconsContainer}
                        style={{
                          top: '50%',
                          left: '50%',

                          width: '300px',
                          position: 'absolute',
                          transform: 'translate(-50%, -50%)',
                        }}
                      >
                        <div>
                          {/* <Link to={`${config.APP_PATHS.newRequest}/${Id}`}> */}
                          <Link to={`${config.APP_PATHS.newRequest}`}>
                            <Button
                              type="longBtn"
                              onClick={() => addNewRequest(Id)}
                            >
                              Pildyti paraišką
                            </Button>
                          </Link>
                        </div>
                      </div>
                    )}
                  </TableCellProject>
                </TableRowProject>
              )
            )}
        </TableProjects>
      </div>

      {canCreateNewRequest ? (
        <Redirect to={config.APP_PATHS.newRequest} />
      ) : null}
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  projectList: state.dashboardState.projectList,
  loading: state.dashboardState.isOnSync,
  canCreateRequest: state.dashboardState.canCreateRequest,
});

export default connect(mapStateToProps)(Projects);
